import { createApp, configureCompat } from "vue";

// PHẢI GỌI TRƯỚC createApp() — nếu đảo thứ tự thì compat MODE không áp dụng cho app instance
// INSTANCE_SET: true — $set dùng bởi 20+ component Vue 2 cũ (msAttachment, mscombobox, msgrid...),
// MODE 3 disable hết → xóa file trong msAttachment4 throw "INSTANCE_SET compat has been disabled"
configureCompat({ MODE: 3, ATTR_FALSE_VALUE: false, INSTANCE_SET: true });

import App from "@/App.vue";

// import "vue-toast-notification/dist/theme-sugar.css";
// import "viewerjs/dist/viewer.css";
import "@misa/ui-control/dist/style.css";

//Add extension
import "./commons/prototype";

// Vue Router
import router from "@/routers/router";

// Vuex Store
import store from "@/stores/store";

// i18n
import i18n from "@/i18ns/i18n";

// filter
import "./filters/filters";

//context menu
import "@/assets/scss/components/vue-context.scss";

// Styles: SCSS
import "@/assets/fonts/SFProDisplay/font.css";
import "@/assets/css/flexbox.css";
import "@/assets/css/common.css";
import "@/assets/scss/scroller.scss";
import "@/assets/scss/override.scss";
import "@/assets/scss/icons.scss";
import "@/assets/scss/jp_icons.scss";
import "@/assets/scss/btn.scss";
import "@/assets/scss/form.scss";
import "@/assets/scss/app.scss";

// Globally Registered Components
import { registerComponents } from "@/commons/globalComponents.js";

// Globally Registered Plugins
import { registerPlugins } from "@/commons/globalPlugin.js";

// MISA packages
import { createPinia } from "pinia";
import MISABaseUI, { useCache, createPiniaCachePlugin } from "@misa/ui-base";
import * as projectConstants from "@/constants";
import MisaUI from "@misa/ui-control";
import { httpOption, permissionConfig } from "@/configs/misaBaseConfig.js";

// Global popup registry — đăng ký tất cả popup components cho useDialog
import { registerGlobalPopup } from "@/commons/globalPopup";

//Kiểm tra phiên bản và trình duyệt
let appVer = window.navigator.userAgent;
if (
  appVer.indexOf("Edge/") > -1 || //edge
  appVer.indexOf(".NET") > -1
) {
  //Ứng dụng không hỗ trợ những trình duyệt này, nên không tạo instance của VueJs
} else {
  (async () => {
    // 1. Khởi tạo cache TRƯỚC TIÊN
    const { initialize } = useCache();
    await initialize(window.JP_CACHE_CONFIG); // Truyền {} để dùng config mặc định

    const pinia = createPinia();
    const cachePlugin = createPiniaCachePlugin({});
    pinia.use(cachePlugin);

    const app = createApp(App);

    if (import.meta.env.DEV) {
      app.config.performance = true;
    }

    app.use(pinia);
    app.use(router);
    app.use(store);
    app.use(i18n);
    app.use(MISABaseUI, { httpOption, permissionConfig, projectConstants });
    app.use(MisaUI, { httpOption, colorPreset: "blue" });
    registerGlobalPopup();

    /**
     * directive xử lý style.visibility
     */
    app.directive("visible", function (el, binding) {
      el.style.visibility = !!binding.value ? "visible" : "hidden";
    });

    registerComponents(app);
    registerPlugins(app);

    app.mount("#app");
  })();
}
